import { useState, useEffect } from 'react';

export default ({
	ref = null,
	onChange = null,
	rootMargin = '0px',
	threshold = [],
	id,
}) => {
	const [intersecting, setIntersecting] = useState(false);
	const [count, setCount] = useState({
		in: 0,
		out: 0,
	});

	useEffect(() => {
		if (!ref || !document.getElementById(id))
			return;

		const observer = threshold.length > 0 ?
			new IntersectionObserver(
				entries =>
					entries.forEach(entry => setIntersecting(entry.isIntersecting)),
				{ threshold }
			) :
			new IntersectionObserver(
				entries =>
					entries.forEach(entry => setIntersecting(entry.isIntersecting)),
				{ rootMargin }
			);

		observer?.observe(ref?.current);

		return () => {
			if (document.getElementById(id))
				observer?.unobserve(ref?.current);
		};
	}, [ref, id]);

	useEffect(() => {
		setCount({
			...count,
			[intersecting ? 'in' : 'out']: count[intersecting ? 'in' : 'out'] + 1,
		});
	}, [intersecting]);

	useEffect(() => {
		if (onChange)
			onChange({ intersecting, count });
	}, [count]);
};
